export const getUserStart = () => ({
  type: "GET_USER_START",
});
export const getUserSuccess = (user) => ({
  type: "GET_USER_SUCCESS",
  payload: user,
});
export const getUserFailure = () => ({
  type: "GET_USER_FAILURE",
});
